import { PropsWithChildren } from 'react';

import { ProtectedRoute as Protected, ROUTE } from '@app-evolution-cms/router';

import { RoleClaim } from '../../users/_types/role-claim';
import { useHasPermission } from './use-has-permission';

interface ProtectedRouteProps {
  fallbackPath?: string;
  roles: RoleClaim[];
}

export function ProtectedRoute({
  children,
  fallbackPath = ROUTE.targetGroups.main,
  roles,
}: PropsWithChildren<ProtectedRouteProps>) {
  const hasPermission = useHasPermission({ roles });
  return (
    <Protected fallbackPath={fallbackPath} hasPermission={hasPermission}>
      {children}
    </Protected>
  );
}
